import "react-datepicker/dist/react-datepicker.css";
import "./styles/calendar.css";
import "./styles/customScrollbar.css";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { UserApp } from "./UserApp";
import { AdminApp } from "./AdminApp";
import { useEffect, useRef } from "react";
import { initApi } from "./services/init";

function App() {
  const auth = useSelector((state) => state?.auth);
  const dispatch = useDispatch();
  const isInitApiInProgress = useRef(false);

  useEffect(() => {
    if (isInitApiInProgress.current) return;
    isInitApiInProgress.current = true;
    initApi(dispatch, auth?.user);
  }, []);

  return (
    <BrowserRouter>
      {!auth?.isLoading &&
        (auth?.user?.role === "admin" ? <AdminApp /> : <UserApp />)}
    </BrowserRouter>
  );
}

export default App;
